import {FavoritesApi} from 'hemwb-api';
import {configuration} from '../getBackendConfiguration';

const favoritesApi = new FavoritesApi(configuration);

export const requestGetFavoriteModelIds = () => favoritesApi.getFavoriteModelIds();

export const requestAddFavorite = (modelUuid: string) => favoritesApi.addFavorite({modelUuid});

export const requestRemoveFavorite = (modelUuid: string) => favoritesApi.removeFavorite({modelUuid});
